import { render, staticRenderFns } from "./certifyTest.vue?vue&type=template&id=430e139a"
import script from "./certifyTest.vue?vue&type=script&lang=js"
export * from "./certifyTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports